import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import {
  IApiResponse,
  ICurbsideDto,
  IDeliveryPickupDto,
  IDeliveryZoneDto,
  IFilterPaginationDto,
  IThirdPartyDeliveryDto,
} from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class DeliveryService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getDeliveryPickupSettings(id: number): Observable<IDeliveryPickupDto> {
    return this.get(`admin/dp/setting/${id}`);
  }

  public updateDeliveryPickupSettings(
    model: IDeliveryPickupDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/dp/setting`, model);
  }

  public getThirdPartyDeliveryList(
    model: IFilterPaginationDto
  ): Observable<IThirdPartyDeliveryDto[]> {
    return this.post(`admin/dp/thirdParty`, model);
  }

  public saveThirdPartyDelivery(
    model: IThirdPartyDeliveryDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/dp/thirdParty/save`, model);
  }

  public changeThirdPartyDeliveryStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/dp/thirdParty/${id}`, null);
  }

  public deleteThirdPartyDeliveryOrder(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/dp/thirdParty/${id}`);
  }

  public updateThirdPartyDeliveryOrder(
    model: KeyValue<number, number>[]
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/dp/thirdParty/order`, model);
  }

  public getCurbsideList(
    model: IFilterPaginationDto
  ): Observable<ICurbsideDto[]> {
    return this.post(`admin/dp/curbside`, model);
  }

  public saveCurbside(model: ICurbsideDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/dp/curbside/save`, model);
  }

  public changeCurbsideStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/dp/curbside/${id}`, null);
  }

  public deleteCurbside(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/dp/curbside/${id}`);
  }

  public getDeliveryZoneList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<IDeliveryZoneDto[]> {
    return this.post(`admin/dp/deliveryZone/${id}`, model);
  }

  public saveDeliveryZone(
    model: IDeliveryZoneDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/dp/deliveryZone/save`, model);
  }

  public changeDeliveryZoneStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/dp/deliveryZone/${id}`, null);
  }

  public deleteDeliveryZone(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/dp/deliveryZone/${id}`);
  }
}
